<template>
  <div class="content-main">
    <div class="page-complain-edit" v-if="!submit_result">
      <div class="part-title">投诉描述</div>
      <textarea id="complain-content" rows="8" cols="20" maxlength="200" placeholder="投诉原因详细说明" v-model="complain.describe"></textarea>

      <div class="btn-submit" id="btn-submit" @click="submitComplain()">提交</div>
    </div>

    <div class="page-success flex-box" v-if="submit_result">
      <img class="img-success" src="https://static.huiyiji520.com/submit-success-210916.png">
      <div class="hint hint1">投诉提交成功！</div>
      <!-- <div class="hint hint2">我们会在1个工作日内完成情况核实</div> -->
      <div class="hint hint2">我们会在3个工作日内审核</div>
      <div class="hint hint2">并处理相关内容</div>
      <div class="hint hint2">感谢反馈！</div>
      <!-- <div class="btn-back" @click="goIndex()">返回首页</div> -->
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'

export default{
  data(){
    return {
      complain: {
        describe: "",
        type: 0
      },
      submit_result: false,
      loading: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },

    submitComplain(){
      var searchParams = new URLSearchParams(window.location.search)
      let type = searchParams.get("type")
      let describe = this.abbrevText(this.complain.describe, 200)
      if(!describe){
        Toast('请填写投诉内容')
        return
      }else if(this.loading){
        return
      }else{
        this.loading = true
        let userid = this.$store.state.userinfo.userid
        let user_type = this.$store.state.userinfo.user_type
        this.$api.post('/complain/create_zhishicheap_wecom', {userid: userid, describe: describe, type: type, user_type: user_type}, res => {
          if(res.code == 200){
            // Toast('投诉成功')
            this.submit_result = true
            this.loading = false
          }
        })
      }
    },

    abbrevText(text, len){
      if(text.length <= len){
        return text.trim()
      }else{
        return text.trim().slice(0, len) + '...'
      }
    },
    setHtmlFontSize () {
      const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      const htmlDom = document.getElementsByTagName('html')[0]
      htmlDom.style.fontSize = htmlWidth / 10 + 'px'
    }
  },
  mounted(){
    this.setHtmlFontSize()
  }
}
</script>

<style scoped>
.content-main{
  text-align:left;
  color:#222;
  font-size:30px;
  background-color:#f4f4f4;
  min-height:100vh;
}
/* .page-complain-edit{text-align:left;background-color:#f6f8f9;} */
.part-title{
  color:#666;
  font-size:26px;
  /* padding:10px 12px; */
  padding-top:60px;
  padding-bottom:20px;
  padding-left: 20px;
}

textarea{width:100%;padding:20px 20px;color:#333;font-size:26px;margin-bottom:50px;}
.btn-submit{
  background:#1aad19;color:white;font-size:26px;height:75px;line-height:75px;
  text-align:center;width:90%;border-radius:5px;margin:0px auto;
}
textarea:focus,input:focus {outline:none;box-shadow:none;-webkit-appearance: none;}
input, textarea{border:none;outline:none;}
*::-webkit-input-placeholder {color: #969799;font-size:26px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:26px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:26px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:26px;}

.page-success{padding-top:150px;flex-direction:column;align-items:center;}
.img-success{width:120px;height:120px;margin-bottom:30px;visibility:visible;}
.page-success .hint{font-size:28px;}
.page-success .hint1{color:#333;margin-bottom:25px;}
.page-success .hint2{color:#333;margin-bottom:8px;}
.page-success .hint3{color:#dd4b39;}
.btn-back{
  background:#4caf50;color:#fff;font-size:26px;height:75px;line-height:75px;
  margin:0 auto;margin-top:30px;width:70%;border-radius:2px;text-align:center;
}
</style>
